// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter '$rootScope' implicitly has an 'any' typ... Remove this comment to see the full error message
const LoggedInMenu = ($rootScope, $authEvents, auth, menuManager) => ({
   replace: true,
   templateUrl: '/assets/loggedInMenu.html',

   link(scope: any) {
      const name = 'loggedInMenu' + scope.$id
      const config = {
         name,
         type: 'dropdown',
         close: ['any']
      }

      const updateProviders = () => {
         scope.disableHeading = false
         scope.uniqueProvider = null
         scope.loggedInProviders = _.filter(auth.scope.auth, (provider: any) => provider.loggedIn)
         scope.loggedOutProviders = _.filter(auth.scope.auth, (provider: any) => !provider.loggedIn)
         scope.features = auth.scope.features
         scope.loggedIn = scope.loggedInProviders.length > 0
         scope.featuresInMenu = _.keys(scope.features).filter((feature: any) => scope.features[feature].showInMenu())
         // features is an object, so checking for keys
         scope.loggedInMenuActive = scope.features && scope.featuresInMenu.length > 0
         // if there is a _single_ provider logged in, that can be used by all existing features, we don't have to show the headings.
         // this checks for that, and then it just only displays a single logout instead of one with headings.
         scope.loggedInFeatures = _.filter(scope.features, (f: any) => { 
            let needle
            const loggedInProvider = auth.getLoggedInProviderForFeature(f.name)
            return needle = loggedInProvider, _.map(f.supportedProviders, (sp: any) => sp.provider).includes(needle)
         })
    
         // now check if the provider is the same for all loggedInFeatures
         if (scope.loggedInFeatures.length === (_.keys(scope.features)).length) {
            scope.disableHeading = _.every(scope.loggedInFeatures, (lf: any) => lf.activeProvider === scope.loggedInFeatures[0].activeProvider)
         } else {
            const providerMem: any = {}
            Object.entries(scope.features).forEach(([key, feature]: [string, any]) => {
               feature.providers.forEach((p: any) => {
                  if(p.enabled) {
                     providerMem[p.name] = providerMem[p.name] ? providerMem[p.name] + 1 : 1
                  }
               });
            })
            scope.disableHeading = Object.values(providerMem).every((value: any) => value === scope.featuresInMenu.length);
         }
         if (scope.disableHeading) {
            // return just one of the features in the scope, so we only display 1 login/out button, 
            // doesn't matter which, since we don't display the heading, only the logout
            // looks a bit funky since we need to create an object with the key being the name of the feature
            const f: any = {}

            const features = Object.values(scope.features)
            if (features && features.length) {
               const firstFeature = scope.features[scope.featuresInMenu[0]]
               if (firstFeature) {
                  f[firstFeature.name] = firstFeature
                  scope.features = f
                  const enabledProviders = firstFeature.providers.filter((provider: any) => provider.enabled)
                  if (enabledProviders.length === 1) {
                     scope.uniqueProvider = enabledProviders[0]
                  }
               }
            }
         }
      }

      scope.getLoggedInUsername = function (providerName: string): string | undefined {
         const loggedInProvider = scope.loggedInProviders.find((provider: any) => provider.displayName === providerName)
         return loggedInProvider?.username
      }

      scope.getLoginProviderDisplayText = function(provider : any): string {
         switch (provider.name) {
            case 'cas':
               return scope.i18n.translate(scope.i18n.translations.LOGIN_WITH_CAS);
            case 'saml':
               return scope.i18n.translate(scope.i18n.translations.LOGIN_WITH_SAML);
            default:
               return scope.i18n.translate(scope.i18n.translations.LOGIN_WITH, {alias: provider.displayName})
         }
      }

      menuManager.registerMenu(config)
      $rootScope.$on($authEvents.LOGOUTSUCCESS, updateProviders)
      $rootScope.$on($authEvents.LOGINSUCCESS, updateProviders)

      scope.onToggle = function(status: any) {
         if (status) {
            return menuManager.subMenu[name].openMenu()
         } else {
            return menuManager.subMenu[name].closeMenu()
         }
      }

      scope.uniqueLoginLogout = function() {
         const feature = scope.features[scope.featuresInMenu[0]]
         if(feature.activeProvider) {
            scope.openLogoutDialog(feature.name, scope.uniqueProvider.name)
         } else {
            scope.login(feature.name, scope.uniqueProvider.name)
         }
      }

      scope.openLogoutDialog = auth.openLogoutDialog
      scope.login = auth.login
      return updateProviders()
   }
})


angular.module('summonApp.directives')
   .directive('loggedInMenu', ['$rootScope', '$authEvents', 'authenticationService', 'menuManagerService', LoggedInMenu])

